





























import { Component, Prop, Vue } from 'vue-property-decorator';

import CloseIcon from '@/components/icons/Close.vue';

import eventBus from '@/utils/eventBus';
import BusinessService from '@/api/BusinessService';

import InStore from '@/components/icons/InStore.vue';
import Online from '@/components/icons/OnlineStore.vue';

import Introduction from './Steps/Introduction.vue';
import Success from './Steps/Success.vue';

import { EBusinessRewardsStatus, IBusinessType } from '@/models/business';
import segmentIo from '@/utils/segment.io';
import { IProvider } from '@/models/provider';
import MerchantService from '@/api/MerchantService';
import { getIsRewardActivated } from '@/utils/rewards';
import { Group } from '@/router/group.model';
import { isRemoteLoading } from '@/utils/remote-loading';

export type ToggleRewardsNextParams = {
  redirectToSlug: string;
};

export enum EToggleRewardsStepSlug {
  INTRODUCTION = 'introduction',
  SUCCESS = 'success'
}

@Component({
  components: {
    CloseIcon,
    Introduction,
    Success,
    InStore,
    Online
  }
})
export default class ToggleRewardsModal extends Vue {
  @Prop() activeRewards!: boolean;
  @Prop() type!: IBusinessType.ONLINE | IBusinessType.INSTORE;
  @Prop() onSuccess?: () => void;
  @Prop() origin?: 'switch' | 'banner';
  @Prop() group?: Group;

  merchantService = new MerchantService();
  loading = false;
  IBusinessType = IBusinessType;
  EToggleRewardsStepSlug = EToggleRewardsStepSlug;

  service = new BusinessService();
  activeStepSlug: string = EToggleRewardsStepSlug.INTRODUCTION;

  get business() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get rewardsType() {
    if ((this.type as any) === IBusinessType.BOTH) return IBusinessType.ONLINE;

    return this.type;
  }

  get colorIcon() {
    if (!this.activeRewards) return '#E32B2E';
    if (this.activeStepSlug === EToggleRewardsStepSlug.SUCCESS)
      return '#20AB63';

    return '#3E24D6';
  }

  get analyticsProps() {
    return {
      Origin: this.origin,
      Page: this.$route.name,
      Action: this.activeRewards ? 'activation' : 'deactivation',
      Operation: this.rewardsType
    };
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  get componentByStepSlug(): {
    [k: string]: {
      component: string;
    };
  } {
    return {
      [EToggleRewardsStepSlug.INTRODUCTION]: {
        component: 'Introduction'
      },
      [EToggleRewardsStepSlug.SUCCESS]: {
        component: 'Success'
      }
    };
  }

  handleGoToStep({ redirectToSlug }: ToggleRewardsNextParams) {
    this.activeStepSlug = redirectToSlug;
  }

  async onFinish(notCloseModal?: boolean) {
    this.loading = true;
    try {
      const status = getIsRewardActivated(this.group)
        ? EBusinessRewardsStatus.INACTIVE
        : EBusinessRewardsStatus.ACTIVE;
      await this.service.putRewardsSettingsStatus({
        status
      });
      this.$store.dispatch('business/SET_REWARD_STATUS', {
        ...this.$store.getters['business/getRewardStatus'],
        operationStatus: status,
        rewardStatus: this.activeRewards
          ? status
          : this.$store.getters['business/getRewardStatus'].rewardStatus
      });

      if (this.onSuccess) this.onSuccess();
      segmentIo.track('Succeed Toggle Loyalty Rewards', this.analyticsProps);
      const response = await this.merchantService.listProviders();
      const providers = response.data.providers as IProvider[];
      await this.$store.dispatch('merchant/SET_PROVIDERS_LIST', providers);
      if (this.activeRewards)
        this.handleGoToStep({
          redirectToSlug: EToggleRewardsStepSlug.SUCCESS
        });
    } finally {
      this.loading = false;
    }
    if (!notCloseModal) this.onClose();
  }

  onClose() {
    eventBus.$emit('closeModal');
  }

  created() {
    segmentIo.modal('Toggle Rewards', this.analyticsProps);
  }
}
